/**
 * 公共函数库
 * @author WangDi
 * @version 0.0.22
 */

import {isUndefined,isObject,isArray,isFunction,isString,isNumber,isElement,isElementArray,isTableElement,isWhat} from "./isWhat";
import {objClone,getObjAttr,setObjAttr,objCover,objClear,objEqual,objExtract} from "./objectOpt";
import {$wd,$wds,showElem,hideElem,insertAfter,insertAfterTable,createElementByHtml,createElemByTemplate,getFormData} from "./dom";
import {parseURL, buildURL} from "./url";
require("./src/array-polyfill");

//=========================================================
//  兼容性处理
//=========================================================
// console
console.log || (console.log = new Function());
console.warn || (console.warn = console.log);
console.error || (console.error = console.log);
console.group || (console.group = console.log);
console.groupEnd || (console.groupEnd = console.log);
// Array.prototype.forEach
isUndefined(Array.prototype.forEach) && (Array.prototype.forEach = function (callback) {
    for (let i = 0; i < this.length; i++) callback(this[i], i, this);
});

/**
 * 遍历对象所有键值 Object.forEach
 * @param callback
 */
Object.forEachIn = function (callback) {
    for (let an in this) {
        if (!this.hasOwnProperty(an)) continue;
        callback(this[an], an, this);
    }
};

//=========================================================
//  Console优化
//=========================================================
/**
 * 五颜六色的Console ~\(≧▽≦)/~
 * <div><img width="1000" src="../img/richLogExample.png"/></div>
 * @param {{title,detail}} options  - 标题和描述
 * @param {...*} [args]     - args及之后的传入参数会被console.log依次输出
 * @memberof $wd
 * @example
 *
 * $wd.richLog(
 *    { title:'日志标题' , detail:'日志详情描述' } ,
 *    param2 ,
 *    param3 ,
 *    ...
 * )
 *
 */
function richLog(options, args) {
    let pathParts;
    try {
        this.error = "just".a.error;
    }
    catch (e) {
        e.stack || (e.stack = {});
        let stackLines = e.stack.split('\n');
        let callerIndex;
        // 找到上级函数在调用栈中的行数
        for (let i in stackLines) {
            if (!stackLines.hasOwnProperty(i)) continue;
            if (!stackLines[i].match(/http[s]?:\/\//)) continue;
            callerIndex = Number(i) + 1;
            break;
        }
        // 提取调用栈信息
        stackLines[callerIndex] || (stackLines[callerIndex] = "");
        pathParts = stackLines[callerIndex].match(/(http[s]?:\/\/.+\/)([^\/]+\.(?:js|html))[^:]*(:[^)]+)/);
        void(pathParts || (pathParts = [stackLines[callerIndex]]));
    }
    // 日志按组输出
    options = options || {};
    console.group(options.title || '日志输出 ' + (new Date()).toLocaleString());
    options.detail && console.log('%c' + options.detail,
        "background-image:-webkit-gradient(linear, left top, right top," +
        "color-stop(0, #f22), color-stop(0.15, #f2f), color-stop(0.3, #22f), color-stop(0.45, #2ff), color-stop(0.6, #2f2),color-stop(0.75, #2f2), color-stop(0.9, #4ff), color-stop(1, #22f) );" +
        "color:transparent; -webkit-background-clip: text;font-size:1.1em;");
    // noinspection JSUnresolvedVariable,JSAnnotator
    console.log("%c调用函数" + (arguments.callee.caller ? arguments.callee.caller.name : "") + "：" + pathParts[0], "color:green");
    [].forEach.call(arguments, function (data, index) {
        index > 0 && console.log(data);
    });
    console.groupEnd();
}



//=========================================================
// 数组操作
//=========================================================
/**
 * 查找是否存在相同数值 遍历检查数组或对象所有的值
 * @param {*} value 查询值
 * @param {number} degree 查询深度
 * @memberof Array.
 */
Array.hasValue = Object.hasValue = function (value, degree) {
    let isMatch = false, searchDegree = degree >= 0 ? degree : -1 >>> 1;
    ( (isObject(this) && Object.forEachIn) || (isArray(this) && [].forEach) ).call(this, function (data) {
        if (data == value) return isMatch = true;
        if (isMatch || searchDegree < 1) return;
        if (isArray(data)) if (Array.hasValue.call(data, value, searchDegree - 1)) return isMatch = true;
        if (isObject(data)) if (Object.hasValue.call(data, value, searchDegree - 1)) return isMatch = true;
    });
    return isMatch;
};

function hasValue(obj, value, degree) {
    return Array.hasValue.call(obj, value, degree);
}

/**
 * 数组遍历
 * @param array 数组
 * @param callback 回调函数 value,index,array
 * @memberof $wd
 */
function forEach(array, callback) {
    [].forEach.call(array, callback);
}

/**
 * 检查数组内是否有目标数据项 简单遍历检查
 * @param array 数组
 * @param targetData 匹配数值
 * @returns {boolean}
 * @memberof $wd
 */
function arrayHas(array, targetData) {
    let isMatch = false;
    [].forEach.call(array, function (data) {
        if (targetData == data) {
            isMatch = true;
        }
    });
    return isMatch;
}

/**
 * 移除数组内与目标数据相同项 会修改原数组
 * @param array 数组
 * @param targetData 目标数据
 * @returns {*}
 * @memberof $wd
 */
function arrayRemove(array, targetData) {
    let newArray = [];
    [].forEach.call(array, function (data) {
        if (data !== targetData) newArray.push(data);
    });
    [].splice.apply(array, [0, array.length].concat(newArray));
    return array;
}

//=========================================================
// 链式调用 Promise
// $wd.promise( function(next){ next(data) }).then( function(next,data){ next() })
// 如果使用 .then.then.sync() 会同步开始调用过程
//=========================================================
/**
 * 链式调用&Promise
 * @param callback {function} 回调函数
 * @returns object
 * @memberof $wd
 * @example
 *
 * $wd.promise(function (next) {
 *    console.log('1');
 *    next();
 * })
 * .then(function (next) {
 *    console.log('2');
 *    next();
 * })
 * .then(function (next) {
 *    console.log('3');
 *    next();
 * }).sync();
 * console.log("start");
 *
 * // => 1 2 3 start
 * // 去掉 .sync()
 * // => start 1 2 3
 *
 */
function promise(callback) {
    let start = false, resolveQueue = [], rejectQueue = [], resolve, reject;
    resolve = function () {
        rejectQueue.shift();
        (resolveQueue.shift() || function () {
        }).apply(this, [resolve, reject].concat([].slice.call(arguments, 0)));
    };
    reject = function () {
        (rejectQueue.shift() || function () {
        }).apply(this, [].concat([].slice.call(arguments, 0)));
        rejectQueue = [];
    };
    setTimeout(function () {
        !start && callback(resolve, reject);
    }, 1);
    return {
        then: function (resolve, reject) {
            resolveQueue.push(resolve);
            rejectQueue.push(reject);
            return this;
        },
        sync: function () {
            start = true;
            callback(resolve, reject);
        }
    };
}

/**
 * 简单AJAX
 * @param config
 */
$wd.ajax = function ajax(config) {
    // 默认配置
    let options = {
        type: 'GET',
        url: '',
        data: null,
        traditional: false,
        dataType: 'json',
        jsonp: 'callback',
        cache: true,
        success: function () {
        },
        error: function () {
        },
        uploading: function (percent) {
            console.log(percent);
        },
        headers: {
            Accept: "application/json, text/plain, */*"
        }
    }, jsonpCallbackName = "jsonp";
    $wd.objCover(options, config);
    let xhr = new XMLHttpRequest();
    // jsonp计数器
    isUndefined(ajax.jsonpCounter) && (ajax.jsonpCounter = 100);
    // 上传状态
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                callback(xhr.responseText);
            } else {
                errCallback(xhr.responseText);
            }
        }
    };
    // 上传进度
    /**
     * @param {{loaded,total}} evt
     */
    xhr.upload.onprogress = function (evt) {
        let loaded = evt.loaded;
        let total = evt.total;
        let percent = Math.floor(100 * loaded / total);
        options.uploading && options.uploading(percent);
    };

    if (options.dataType.toLocaleLowerCase() == 'jsonp') {
        jsonpCallbackName = jsonpCallbackName + ajax.jsonpCounter++;
        window[jsonpCallbackName] = function (data) {
            callback(data);
        };
        let pageScript = document.createElement('script');
        pageScript.type = 'text/javascript';
        pageScript.src = createQueryUrl(true);

        document.head.appendChild(pageScript);
        pageScript.onload = function () {
            delete window[jsonpCallbackName];
        };
        pageScript.onerror = function () {
            errCallback('jsonp加载失败');
        };
    } else {
        // 启动请求
        switch (options.type.toUpperCase()) {
            case 'GET':
                doGet();
                break;
            case 'POST':
                doPost();
                break;
            default:
                break;
        }
    }

    function createQueryUrl(jsonp) {
        if (jsonp) {
            return (createQueryUrl() + '&' + options.jsonp + '=' + jsonpCallbackName).replace(/\?$/, "");
        }
        return (options.url + '?' + serialDataToQuery(options.data)).replace(/\?$/, "");
    }

    function callback(resourceData) {
        let dataPreProcessing = {
            'json': function () {
                try {
                    return JSON.parse(resourceData);
                } catch (e) {
                    console.log("Error:不合法的JSON字符串:" + resourceData);
                }
            },
            'jsonp': function () {
                return resourceData;
            },
            'html': function () {
                return resourceData;
            }
        };
        let dataType = options.dataType.toLocaleLowerCase();
        options.success && options.success(dataPreProcessing[dataType] && dataPreProcessing[dataType]());
    }

    function errCallback(msg) {
        options.error && options.error(msg);
    }

    function serialDataToQuery(data) {
        if (isObject(data)) {
            let queryList = [];
            for (let an in data) {
                if (!data.hasOwnProperty(an)) continue;
                queryList.push(an + '=' + data[an]);
            }
            return queryList.join('&');
        }
        console.error("暂时只支持对象作为数据！");
    }

    function doGet() {
        xhr.open("GET", createQueryUrl());
        for (let name in options.headers) {
            if (!options.headers.hasOwnProperty(name)) continue;
            xhr.setRequestHeader(name, options.headers[name]);
        }
        // 直接发送数据
        xhr.send(options.data);
    }

    function doPost() {
        xhr.open("post", options.url);
        // 直接发送数据
        xhr.send(serialDataToQuery(options.data));
    }

};


/**
 * 检查为空的数据项
 * @param {object|array}  obj 检查目标,对象 对象数组
 * @param callback 检查到空值触发回调 参数 value name
 * @param {(array|string)=} exception 例外的属性名称列表
 * @returns {boolean} 如果有空值返回false
 * @memberof $wd
 * @example
 *
 * // 示例
 * let obj = {a:1,b:'',c:''};
 * console.log( $wd.checkEmpty(obj, function (name) {
     *     console.log(name);
     * }) );
 * // => b,false
 * console.log( $wd.checkEmpty(obj, function (name) {
     *     console.log(name);
     * }),'b');
 * // => c,false
 * console.log( $wd.checkEmpty(obj, function (name) {
     *     console.log(name);
     * }),'b,c');
 * // => true
 *
 */
function checkEmpty(obj, callback, exception) {
    let originObj = obj, ignoreList = [];
    if (isObject(obj)) {
        originObj = [];
        originObj.push(obj);
    }
    exception && (ignoreList = isArray(exception) ? exception : exception.split(','));
    let isMatch = false;
    originObj.forEach(function (data) {
        Object.forEachIn.call(data, function (value, name) {
            if (arrayHas(ignoreList, name) || isMatch) return;
            if ((value == '' && value !== 0 && value !== false) || isUndefined(value)) {
                callback(name, data);
                isMatch = true;
            }
        });
    });
    return !isMatch;
}



//=========================================================
//  异步加载资源
//=========================================================
/**
 * 获取JS
 * @param {string} src JS路径
 * @param {function} callback 获取成功后回调
 * @returns {boolean} 返回true表示页面上没有这个JS开始进行加载，返回false表示已经存在这个JS文件不进行加载
 * @memberof $wd
 */
function getScript(src, callback) {
    // 页面脚本
    if (src) {
        let curScripts = document.querySelectorAll('script');
        for (let i = 0; i < curScripts.length; i++) {
            if (curScripts[i].getAttribute('src') == src) {
                callback('exist');
                return false;
            }
        }
        let pageScript = document.createElement('script');
        pageScript.type = 'text/javascript';
        pageScript.src = src;
        document.head.appendChild(pageScript);
        pageScript.onload = function () {
            console.log("JS加载成功:[" + this.getAttribute('src') + "]");
            callback(true);
        };
        pageScript.onerror = function () {
            console.log("有个路径为:[" + this.getAttribute('src') + "]的文件没有加载成功！咋办呢/(ㄒoㄒ)/~~");
            callback('error');
        };
    }
}

//=========================================================
//  时间
//=========================================================
/**
 * 时间格式化
 * @param {string} fmt 时间格式化字符串
 * @example
 * y : year
 * M : month
 * h : hour
 * m : minute
 * s : second
 * q : quarter
 * S : millisecond
 */
isUndefined(Array.prototype.format) && (Date.prototype.format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1,  // 月份
        "d+": this.getDate(),       // 日
        "h+": this.getHours(),      // 小时
        "m+": this.getMinutes(),    // 分
        "s+": this.getSeconds(),    // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3),    // 季度
        "S": this.getMilliseconds()                     // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ?
                (o[k]) :
                (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
});

/**
 * 时间间隔
 * @param targetDate
 * @param cmpDate
 * @memberof $wd
 * @returns {{gapSeconds: Number, gapMinutes: Number, gapHours: Number, gapDate: Number}}
 * @memberof $wd
 */
function getDateInterval(targetDate, cmpDate) {
    let gap = (targetDate - (cmpDate ? cmpDate : new Date())) / 1000;
    return {
        gapSeconds: parseInt(gap % 60),
        gapMinutes: parseInt(gap / (60)) % 60,
        gapHours: parseInt(gap / (60 * 60)) % 24,
        gapDate: parseInt(gap / (60 * 60 * 24))
    }
}

/**
 * 获取定制图片
 * @param url 原始URL
 * @param sizeX 图片尺寸
 * @param sizeY 图片尺寸
 * @param rotate 图片旋转角度
 * @memberof $wd
 * @example
 *
 *      let url = http://saas.fd.zol-img.com.cn/g5/M00/07/02/ChMkJlfqD_-ICNLsAABmZQKtIzsAAWZlAI7CmAAAGZ9169.jpg
 *      $wd.getCustomizedImage(url,90,90,180)
 *      // => http://saas.fd.zol-img.com.cn/t_s90x90_r180/g5/M00/07/02/ChMkJlfqD_-ICNLsAABmZQKtIzsAAWZlAI7CmAAAGZ9169.jpg
 *
 */
function getCustomizedImage(url, sizeX, sizeY, rotate) {
    let path = parseURL(url).path;
    let origin = parseURL(url).origin;
    let reg = /(?:^\/t(?:_s(\d+)x(\d+))?(?:_r(\d+))?)?/;
    let imageInfo = {
        sizeX: sizeX || path.match(reg)[1] || 0,
        sizeY: sizeY || path.match(reg)[2] || 0,
        rotate: rotate || path.match(reg)[3] || 0
    };
    path = path.replace(reg, "");
    if (imageInfo.sizeX <= 0 || imageInfo.sizeY <= 0) {
        path = "\\t_r" + imageInfo.rotate + path;
    } else {
        path = "\\t_s" + imageInfo.sizeX + "x" + imageInfo.sizeY + "_r" + imageInfo.rotate + path;
    }
    return origin + path;
}


/**
 * 集中调度封装
 * 封装函数的调用过程，置入钩子函数来过滤参数、控制执行过程
 * @param {object} obj  需要封装调用的方法集合
 * @param {function=} hookFunc 置入调用过程的钩子函数 第一个参数为函数自身 第二个参数为函数调用参数
 * @memberof $wd
 */
function invokeProxy(obj, hookFunc) {
    let callback = $wd.isFunction(hookFunc) ? hookFunc : function () {
        return true;
    };
    for (let an in obj) {
        if (!obj.hasOwnProperty(an)) continue;
        if ($wd.isFunction(obj[an])) {
            !function () {
                let func = obj[an];
                obj[an] = function () {
                    return callback(func, arguments) && func.apply(this, arguments);
                };
            }();
        }
    }
    return obj;
}

//=========================================================
//  对外提供的功能
//=========================================================
// $wd
$wd.objClone = objClone;
$wd.getObjAttr = getObjAttr;
$wd.createElementByHtml = createElementByHtml;
$wd.castElemByTemplate = createElemByTemplate;
$wd.createElemByTemplate = createElemByTemplate;

$wd.parseURL = parseURL;
$wd.buildURL = buildURL;
$wd.showElem = showElem;
$wd.hideElem = hideElem;

$wd.forEach = forEach;
$wd.arrayHas = arrayHas;
$wd.arrayRemove = arrayRemove;
$wd.getFormData = getFormData;
$wd.insertAfter = insertAfter;
$wd.insertAfterTable = insertAfterTable;

$wd.objCover = objCover;
$wd.objClear = objClear;
$wd.objEqual = objEqual;
$wd.objExtract = objExtract;
$wd.setObjAttr = setObjAttr;
$wd.checkEmpty = checkEmpty;

$wd.promise = promise;
$wd.richLog = richLog;
$wd.getScript = getScript;
$wd.invokeProxy = invokeProxy;
$wd.getDateInterval = getDateInterval;
$wd.getCustomizedImage = getCustomizedImage;

// export
$wd.$wd = $wd;
$wd.$wds = $wds;
$wd.richLog = richLog;
$wd.isArray = isArray;
$wd.isNumber = isNumber;
$wd.isObject = isObject;
$wd.isString = isString;
$wd.isElement = isElement;
$wd.isFunction = isFunction;
$wd.isUndefined = isUndefined;
$wd.isElementArray = isElementArray;
$wd.isTableElement = isTableElement;

$wd.isWhat = isWhat;
$wd.hasValue = hasValue;

// module.exports = $wd;
export default $wd;
